const initialState = {
  loading: false,
  movieOfgenre: [],
  error: "",
};

const genreOfmovieReducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case "GENRE_OF_MOVIE_FETCH_REQUEST":
      return {
        ...state,
        loading: true,
      };

    case "GENRE_OF_MOVIE_FETCH_SUCCESS":
      return {
        loading: false,
        movieOfgenre: payload,
      };

    case "GENRE_OF_MOVIE_FETCH_FAILURE":
      return {
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default genreOfmovieReducer;
